import Vue from 'vue'
import App from './App.vue'
import router from './router'
import titleMixin from './utils/title';
import VueLazyload from 'vue-lazyload';
import { Toast } from 'vant';

Vue.use(Toast);
Vue.config.productionTip = false
Vue.mixin(titleMixin);

// 引用图片懒加载
Vue.use(VueLazyload, {
  preLoad: 1,
  error: '//x.autoimg.cn/cfw/cfw/carcomment/carcomment-complaint-platform/placeholder-img.png',
  loading: '//x.autoimg.cn/cfw/cfw/carcomment/carcomment-complaint-platform/placeholder-img.png',
  attempt: 1
});

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
